export default "skymp5-front/84c3dd670c1f3e18f470d09abd820854.png";